import { useState } from "react";

import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { Article } from "models";
import type { CreateArticleFormValues } from "modules/NewsDashboard/components/ArticleModal/ArticleForm";

export const useUpdateArticleMutation = () => {
  const [hasValidationErrors, setHasValidationErrors] = useState(false);

  const validateArticle = (article: CreateArticleFormValues) => {
    const hasErrors = !article.title || (!article.location_ids.length && !article.dealer_ids.length && !article.visible_to_all) || !article.selector || !article.content;
    setHasValidationErrors(hasErrors);
    return hasErrors;
  };

  const { mutateAsync, isPending } = useTypedMutation<Article, void>({
    mutationFn: async formData => {
      await ApiInstance.post("/articles/update", formData, ENV.dealerBaseURL);
    },
    onSuccess: () => null
  });

  return { updateArticleMutation: mutateAsync, isPending, validateArticle, hasValidationErrors };
};
